module.exports = __webpack_public_path__ + "static/media/strutture-campo-beachvolley-linee-noleggiocampi.ccc98128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/beachvolley/slider1/strutture-campo-beachvolley-linee-noleggiocampi.jpg
// module id = 637
// module chunks = 0